module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_2-d80207d891a08ad62cbfc7f37f4b011c.jpg";